// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"461":"skills","554":"examples","594":"about"}[chunkId] + "." + {"461":"e6cf84d3","554":"37e84764","594":"d23c2272"}[chunkId] + ".js";
};